import { use, useEffect, useRef, useState } from "react";
import { GridLayout, HorizontalLayout } from "../layout";
import { QuizStepper } from "../quizStepper";
import { AssessmentFactory } from "../../factory/assessmentContentFactory";
import { Melding } from "../../atoms/melding";
import { VideoPlayerAssessment } from "../../atoms/video";
import { ButtonBar } from "../../molecule/buttonBar";
import { ip, postAPI } from "../../api/api";
import { AssessmentTitle } from "../../molecule/assessmentTitle";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";
import { set } from "date-fns";
import testVideo from "../../assets/video/dashboard-intro.mp4";
import { IconButton } from "../../atoms/buttons";

export default function AssessmentPage({ elearningInformation, setFinished, id, interactionEmbed, setLeadEmail }) {
  const [message, setMessage] = useState("");
  const [messageAnimation, setMessageAnimation] = useState("");
  const [animationClass, setAnimationClass] = useState("animate-in");
  const [avatarVideoMini, setAvatarVideoMini] = useState(true);
  const [embedStructure, setEmbedStructure] = useState({});
  const [loading, setLoading] = useState(false);
  const [quizStructure, setQuizStructure] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [currentAssessment, setCurrentAssessment] = useState(0);
  const [maxReachedModule, setMaxReachedModule] = useState(0);
  const answerTextTimer = useRef(null);
  const [autoPlay, setAutoPlay] = useState(false);
  const isAssessmentReady = !loading && embedStructure.length > 0 && embedStructure[currentAssessment];
  useEffect(() => {
    loadAssesment(id);
  },[])

  const setupEmbedStructure = async (authToken) => {
    try {
      const embed_structure = await (await fetch(`${ip}/api/embed/${id}/structure`, {
        headers: { "X-Auth-Token": authToken }
      })).json();
      const serverData = embed_structure["data"] || [];
      try {
        const stored = JSON.parse(localStorage.getItem(`embed_${id}`)) || {};
        const answers = stored?.answers || {};
        const merged = serverData.map((m, idx) => {
          const saved = answers[idx];
          if (!saved) return m;
          if (Array.isArray(saved?.answer_content) && Array.isArray(m?.module_content?.quiz_answers)) {
            return { ...m, module_content: { ...m.module_content, quiz_answers: saved.answer_content } };
          }
          if (typeof saved?.answer_content === "string" && m?.module_content?.quiz_answers && typeof m.module_content.quiz_answers === "object") {
            return { ...m, module_content: { ...m.module_content, quiz_answers: { ...m.module_content.quiz_answers, quiz_answer: saved.answer_content } } };
          }
          return m;
        }
        );
        setQuizStructure([
          {
            title: elearningInformation?.title || "Inhoud",
            collapsed: false,
            progress: 0,
            modules: merged.map((m, index) => ({ ...m, indexCounter: index }))
          },
        ]);
        setEmbedStructure(merged);
      } catch { setEmbedStructure(serverData); }
    } catch (err) { console.error("setupEmbedStructure error", err); setEmbedStructure([]); }
  };

  const getDeviceFP = async () => {
    const fp = await getFingerprint({ logging: false }).hash ?? crypto.randomUUID();
    localStorage.setItem("device_token", fp);
    return fp
  };
  useEffect(() => {
      fetchEmail().then(email => {
        if (email) setLeadEmail(email);
      })
  }, [])

  const fetchEmail = async () => {
    const d_token = getAnonymousUserID();

    const res = await fetch(`${ip}/api/embed/${id}/email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ d_token })
    });

    const data = await res.json();
    console.log("fetched email", data);
    return data?.data?.email || null;
  }

  const generateAccessToken = async () => {
    if (!id) return;
    let d_token = getAnonymousUserID()
    console.log(d_token)
    try {
      const res = await fetch(`${ip}/api/embed/${id}/start`, {
        method: "POST",
        body: JSON.stringify({ d_token: d_token, up: false  }),
        headers: { "content-type": "application/json" }
      });
      
      const data = await res.json(); 
      const token = data?.data?.access_token;
      if (token) localStorage.setItem(`embed_${id}`, JSON.stringify({ token, current_module: 0 }));
    } catch (err) { console.error("generateAccessToken error", err); }
  };


  const getAnonymousUserID = () => {
  const key = "device_token";
  let id = localStorage.getItem(key);

  if (!id) {
    id = crypto.randomUUID(); 
    localStorage.setItem(key, id);
  }
  return id;
};

  const loadAssesment = async () => {
    setLoading(true);
    if (!localStorage.getItem(`embed_${id}`)) await generateAccessToken();
    const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
    const authToken = parsed?.token;


    await setupEmbedStructure(authToken);
    interactionEmbed("started_embed")
    setTimeout(() => {
      setCurrentAssessment(parsed.current_module || 0);
    }, 250);
    setLoading(false);
  };


  const saveLocalAnswer = (moduleIndex, payload) => {
    const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
    const answers = parsed.answers || {};
    answers[moduleIndex] = payload;
    localStorage.setItem(`embed_${id}`, JSON.stringify({ ...parsed, answers }));
  };

  const submitAnswer = async (answer_content) => {
    try {
      const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
      const authToken = parsed?.token;
      if (!authToken) return;
      const current = embedStructure?.[currentAssessment];
      await fetch(`${ip}/api/embed/${id}/answer`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
        body: JSON.stringify({
          module_index: currentAssessment,
          id_modules: current?.id_modules,
          quiz_type: current?.module_content?.quiz_type,
          answer_content
        })
      });
    } catch { }
  };

  const clickAnswerHandler = (index) => {
    const copy = [...embedStructure];
    const current = copy[currentAssessment];
    const answers = current?.module_content?.quiz_answers;
    if (!Array.isArray(answers) || answers[index] === undefined) return;
    answers[index].chosen = !answers[index].chosen;
    copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: [...answers] } };
    setEmbedStructure(copy);
    saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: answers });
    submitAnswer(answers);
  };

  const updateOrderHandler = (value) => {
    const copy = [...embedStructure];
    const current = copy[currentAssessment];
    copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: value } };
    setEmbedStructure(copy);
    saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: value });
    submitAnswer(value);
  };

  const updateMatchHandler = (value) => {
    saveLocalAnswer(currentAssessment, { quiz_type: embedStructure?.[currentAssessment]?.module_content?.quiz_type, answer_content: value });
    submitAnswer(value);
  };

  const answerTextHandler = (value) => {
    const copy = [...embedStructure];
    const current = copy[currentAssessment];
    const qa = current?.module_content?.quiz_answers || {};
    const updatedQA = { ...(qa || {}), quiz_answer: value };
    copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: updatedQA } };
    setEmbedStructure(copy);
    saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: value });
    if (answerTextTimer.current) clearTimeout(answerTextTimer.current);
    answerTextTimer.current = setTimeout(() => submitAnswer(value), 400);
  };

  const hasAnswers = (current) => {
    const quizType = Number(current?.module_content?.quiz_type);
    const answers = current?.module_content?.quiz_answers;
    switch (quizType) {
      case 1: case 3: case 5: return Array.isArray(answers) && answers.some(a => a.chosen);
      case 2: case 4: return true;
      case 6: return typeof answers?.quiz_answer === "string" && answers.quiz_answer.trim().length > 0;
      default: return true;
    }
  };


  const goNext = () => {
    if (!isAssessmentReady) return;
    const current = embedStructure?.[currentAssessment];
    if (!hasAnswers(current)) {
      setMessage("Je moet een antwoord selecteren voordat je verder kunt gaan.");
      setMessageAnimation("fade-in-bottom-to-top");
      setTimeout(() => { setMessageAnimation("fade-out-top-to-bottom"); setTimeout(() => setMessage(""), 1000); }, 3000);
      return;
    }
    setAnimationClass("animate-out");
    setMessage(""); setMessageAnimation("");
    setTimeout(() => {
      if (currentAssessment < embedStructure.length - 1) { setCurrentAssessment(v => v + 1); interactionEmbed("next_question") }
      else handleFinish();
      setAnimationClass("animate-in");
    }, 200);
    setQuizStructure([
      {
        title: elearningInformation?.title || "Inhoud",
        collapsed: false,
        progress: currentAssessment + 1,
        modules: embedStructure.map((m, index) => ({ ...m, indexCounter: index }))
      },
    ]);
    setMaxReachedModule(prev => Math.max(prev, currentAssessment));
  };

  const handleFinish = () => {
    setFinished(true);
    interactionEmbed("finished_assessment");
  }

  const goBack = () => {
    if (currentAssessment > 0) {
      setAnimationClass("animate-out-back");
      setTimeout(() => { setCurrentAssessment(v => v - 1); setAnimationClass("animate-in-back"); setMessage(""); setMessageAnimation(""); }, 200);
    }
  };

  const toggleCollapse = (id) => {
    const copy = [...quizStructure];
    if (copy[id]) copy[id].collapsed = !copy[id].collapsed;
    setQuizStructure(copy);
  };


  const goToSection = (index) => {
    setCurrentAssessment(index);
    setMessage(""); setMessageAnimation("");
  };

  const [phoneCollapse, setPhoneCollapse] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setAvatarVideoMini(false);
    } else {
      setAvatarVideoMini(true);
    }
  }, [isMobile])
  // const src = testVideo;
  const src = embedStructure[currentAssessment]?.video;
  const videoSpeed = embedStructure[currentAssessment]?.video_speed;
  const width = isMobile && !avatarVideoMini ? "auto" : !isMobile && !avatarVideoMini ? "50%" : "100%";
  const height = (src && isMobile && phoneCollapse ? "75vh" : src && isMobile && !avatarVideoMini && !phoneCollapse ? "50vh" : "") || (isMobile && !src && "100dvh");
  
  console.log("data", embedStructure[currentAssessment]);

  return (
    <div style={{ background: "var(--grey-50)", height: "unset" }}>
      <div style={{ backgroundImage: `url('${elearningInformation.image_url}')` }} className="topbar-embed-bg">
        <div className="topbar-embed">{elearningInformation.title}</div>
      </div>
      <div className="container" style={{ margin: "0", height: isMobile ?"calc(-5rem + 100dvh)" :"calc(-8.5rem + 100dvh)" }}>
        <HorizontalLayout style={{ alignItems: "flex-start" }}>
          <QuizStepper
            setMaxReachedModule={setMaxReachedModule}
            maxReachedModule={maxReachedModule}
            activeSection={currentAssessment}
            quizStructure={quizStructure}
            goToSection={(index) => goToSection(index)}
            toggleCollapse={toggleCollapse}
            marginTop={true}
            style={{ overflow: "hidden" }}
          />
 <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", width: "100%", justifyContent: isMobile ? "flex-start" : "center", alignItems: isMobile ? "center" : "flex-start", boxSizing: "border-box", height: isMobile ?"calc(-5.5rem + 100dvh)":"calc(-8.5rem + 100dvh)" }} className={`flex quiz-step-wrapper ${animationClass}`} key={currentAssessment}>
      <div style={{marginRight: "clamp(2rem, 10vw, 10rem)", marginLeft: "clamp(2rem, 10vw, 10rem)", width: width, padding: "1rem", overflow:embedStructure[currentAssessment]?.module_type ==  4 && "unset" }} data-testid="assesment-comp" className="assesment-comp-fix vertical quiz-comp phone-quiz standard-shadow standard-border">
              <AssessmentTitle
                assessment={{
                  title: embedStructure?.[currentAssessment]?.title,
                  description: embedStructure?.[currentAssessment]?.module_content?.quiz_question,
                }}
                visible={true}
              />
              <AssessmentFactory
                module_type={embedStructure[currentAssessment]?.module_type}
                data={embedStructure[currentAssessment]?.module_content}
                clickAnswer={clickAnswerHandler}
                updateOrder={updateOrderHandler}
                updateMatch={updateMatchHandler}
                answerText={answerTextHandler}
              />
              <Melding message={message} animationClass={messageAnimation} />
            </div>
            {!avatarVideoMini && isMobile && (
              <VideoPlayerAssessment
                videoSpeed={videoSpeed}
                autoPlay={autoPlay}
                setCollapsed={setCollapsed}
                collapsed={collapsed}
                setPhoneCollapse={setPhoneCollapse}
                phoneCollapse={phoneCollapse}
                src={src}
              />
            )}
          </div>
        </HorizontalLayout>
      </div>
      {avatarVideoMini && (
        <VideoPlayerAssessment
          videoSpeed={videoSpeed}
          autoPlay={autoPlay}
          setCollapsed={setCollapsed}
          collapsed={collapsed}
          setPhoneCollapse={setPhoneCollapse}
          phoneCollapse={phoneCollapse}
          src={src}
        />
      )}
     <div style={{ gridArea: "2 / 1 / 3 / 3", "padding": "1rem", "background": "var(--card-background-color)", borderTop: "1px solid var(--border-color)" ,marginTop:"auto"}}>
        <GridLayout columnsTemplate="1fr auto">
          <IconButton size={24} icon2={autoPlay ? "auto-play" : "mute"} onClick={() => setAutoPlay(!autoPlay)} color={autoPlay ? "success-500" : "error-500"} style={{ marginRight: "auto", padding: "0 1rem"}} />
          <ButtonBar next={goNext} disabled={!isAssessmentReady} back={goBack} />
        </GridLayout>
      </div>
    </div>
  );
};